import React, {useEffect, useState} from "react";
import globalStyle from '@/styles/Global.scss'
import style from './card.scss'
import Layout from "@/layout/Layout";
import {useHistory} from "react-router";
import {getCardList} from "@/api/card";
import ImageCard from "@/components/ImageCard";
import MButton from "@/components/atom/MButton";

const Cards = () => {
  const history = useHistory()
  const [cards, setCards] = useState([])

  useEffect(() => {
    (async () => {
      const cards = await getCardList()
      setCards(cards)
    })()
  }, [])

  const toWatashiDetail = (id) => {
    history.push(`/watashi/${id}`)
  }

  const toMenu = () => {
    history.push(`/menu`)
  }

  const toUpload = () => {
    history.push('/card/upload')
  }

  return (
    <Layout title={'登録名刺'}>
      <>
        <div className={globalStyle.container}>
          <MButton image={'back.png'} value={'戻る'} onClick={toMenu}></MButton>
          {
            cards.length === 0 &&
            <div>
              名刺の登録がありません。<br/>
              <span className={globalStyle.link} onClick={toUpload}>コチラ</span>から、最初の名刺を登録してください。
            </div>
          }
          {
            cards.map((c) => {
              return <React.Fragment key={c.id}>
                <div className={style.cardName}>{ c.name }</div>
                <div>
                  <ImageCard id={c.id} onClick={() => toWatashiDetail(c.id)}></ImageCard>
                </div>
              </React.Fragment>
            })
          }
        </div>
      </>
    </Layout>
  )
}

export default Cards;
